export default __webpack_public_path__ + "static/media/grimfolks-footer.ec318499.png";